<div class="settings-modal-content">
  <h2 class="mat-h2">Prompts</h2>
  <div class="px-5 mb-4 max-w-fit">
    <app-note
      [text]="centerNewsDescription"
      [severity]="centerNewsSeverity"
    ></app-note>
  </div>
  <div class="flex items-center justify-center" *ngIf="params.selectedProject">
    <mat-form-field appearance="fill" class="w-full !h-32">
      <mat-label>Center news prompt</mat-label>
      <textarea
        class="!h-24"
        matInput
        placeholder="Enter prompt for center news"
        [(ngModel)]="params.selectedProject.centerNewsPrompt"
      ></textarea>
    </mat-form-field>
  </div>
</div>
